export interface LayerCanvas {
  readonly canvas: HTMLCanvasElement;
  readonly ctx: CanvasRenderingContext2D;
}

export function createLayerCanvas(zIndex: number, interactive = false): LayerCanvas {
  const canvas = document.createElement('canvas');
  canvas.style.position = 'absolute';
  canvas.style.inset = '0';
  canvas.style.zIndex = String(zIndex);
  canvas.style.pointerEvents = interactive ? 'auto' : 'none';
  const ctx = canvas.getContext('2d');
  if (!ctx) {
    throw new Error('Failed to initialize World2DRenderer canvas context.');
  }
  return { canvas, ctx };
}

export function createOverlayLayer(zIndex: number): HTMLDivElement {
  const layer = document.createElement('div');
  layer.style.position = 'absolute';
  layer.style.inset = '0';
  layer.style.zIndex = String(zIndex);
  layer.style.pointerEvents = 'none';
  layer.style.overflow = 'hidden';
  return layer;
}

export function syncLayerCanvasSize(canvas: HTMLCanvasElement, width: number, height: number, overscanPx = 0): void {
  const logicalWidth = width + (overscanPx * 2);
  const logicalHeight = height + (overscanPx * 2);
  const devicePixelRatio = window.devicePixelRatio || 1;
  const nextWidth = Math.max(1, Math.round(logicalWidth * devicePixelRatio));
  const nextHeight = Math.max(1, Math.round(logicalHeight * devicePixelRatio));
  if (canvas.width !== nextWidth) {
    canvas.width = nextWidth;
  }
  if (canvas.height !== nextHeight) {
    canvas.height = nextHeight;
  }
  canvas.style.width = `${logicalWidth}px`;
  canvas.style.height = `${logicalHeight}px`;
}

export function syncOverlayLayerSize(layer: HTMLDivElement, width: number, height: number, overscanPx = 0): void {
  const logicalWidth = width + (overscanPx * 2);
  const logicalHeight = height + (overscanPx * 2);
  layer.style.width = `${logicalWidth}px`;
  layer.style.height = `${logicalHeight}px`;
}

export function configureLayerContext(layer: LayerCanvas, container: HTMLElement, overscanPx = 0): void {
  const devicePixelRatio = window.devicePixelRatio || 1;
  layer.ctx.setTransform(devicePixelRatio, 0, 0, devicePixelRatio, overscanPx * devicePixelRatio, overscanPx * devicePixelRatio);
  layer.ctx.clearRect(-overscanPx, -overscanPx, container.clientWidth + (overscanPx * 2), container.clientHeight + (overscanPx * 2));
}

export function applyWorldLayerOverscanStyle(element: HTMLElement, overscanPx: number): void {
  element.style.left = `${-overscanPx}px`;
  element.style.top = `${-overscanPx}px`;
  element.style.inset = 'auto';
}
